<template>
  <div class="diagnosisBoard">
    <new-report-form v-if="showNewReportForm"
                     :reDiagnosisReportId="reDiagnosisReportId"
                     :diagnosisType="diagnosisType"
                     @onShowDiagnosisClick="onShowDiagnosisClick" />
    <board-content @onShowDiagnosisClick="onShowDiagnosisClick"
                   @onRetryDiagnosis="onRetryDiagnosis" />
 </div>
</template>

<script>
import newReportForm from '../NewReportForm'
import BoardContent from './BoardContent'

export default {
  name: 'DiagnosisBoard',
  components: {
    newReportForm,
    BoardContent
  },
  data () {
    return {
      showNewReportForm: true,
      reDiagnosisReportId: null,
      diagnosisType: 'authoring'
    }
  },
  methods: {
    onShowDiagnosisClick (diagnosisType) {
      this.diagnosisType = diagnosisType
    },
    onRetryDiagnosis (id) {
      this.reDiagnosisReportId = id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/valid-member/dashboard/index.vue